import { useTranslation } from "next-i18next";
import React from "react";

import { Text, TypeSizes } from "@/components/elements/Text";
import { Product } from "@/types/api/products";
import { formatCurrency, formatPricePerLitre } from "@/utils/format";

import styles from "./styles.module.css";

export type ProductInfoBlockProps = {
  textSize?: "regular" | "large";
  product: Pick<Product, "title" | "price" | "brand" | "size">;
  className?: string;
};

export const ProductInfoBlock = ({
  textSize = "regular",
  product,
  className,
}: ProductInfoBlockProps) => {
  const { t } = useTranslation();

  const { title, price, brand, size } = product;
  const topLineSize: TypeSizes = textSize === "large" ? "m" : "s";
  const bottomLineSize: TypeSizes = textSize === "large" ? "s" : "xs";

  return (
    <div className={className}>
      <div className={styles.titlePrice}>
        <Text as="div" size={topLineSize}>
          {t(title)}
        </Text>
        <Text as="div" size={topLineSize}>
          {formatCurrency(price)}
        </Text>
      </div>
      <div className={styles.brandSize}>
        <Text as="div" size={bottomLineSize} className={styles.brand}>
          {brand}
        </Text>
        <Text as="div" size={bottomLineSize}>
          {formatPricePerLitre(price, size)}
        </Text>
      </div>
    </div>
  );
};
